var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-uploader',{attrs:{"after-read":_vm.afterRead,"capture":"camera"}},[_c('img',{staticClass:"scan",attrs:{"src":_vm.scanImg}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }